import React, { useState } from "react";
import ModalSkeleton from "../ModalSkeleton/ModalSkeleton";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./ChangePasswordModal.module.css";
import MailIcon from "@mui/icons-material/Mail";
import LockIcon from "@mui/icons-material/Lock";
import Button from "../Button/Button";
import Input from "../Input";
import { apiHeader, BaseURL, passwordRegex } from "../../config/apiUrl";
import { toast } from "react-toastify";
import { Patch } from "../../Axios/AxiosFunctions";
import { useDispatch, useSelector } from "react-redux";
import { saveLoginUserData } from "../../redux/auth/authSlice";

const ChangePasswordModal = ({ show, setShow }) => {
  const dispatch = useDispatch();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [reNewPassword, setReNewPassword] = useState("");
  const accessToken = useSelector((state) => state?.authReducer?.access_token);

  const [isLoading, setIsLoading] = useState(false);

  // handlePasswordChange
  const handlePasswordChange = async () => {
    const url = BaseURL("users/updateMyPassword");

    if (oldPassword === "" || newPassword === "" || reNewPassword === "")
      return toast.warn("All fields are required.");

    if (newPassword?.length < 8)
      return toast.warn("Password should be atleast 8 characters long.");

    // if (!passwordRegex.test(newPassword))
    //   return toast.warn(
    //     "New password must contain 1 lowercase and 1 uppercase letter, along with 1 symbol."
    //   );

    if (newPassword !== reNewPassword)
      return toast.warn("Password did not matched.");

    const params = {
      passwordCurrent: oldPassword,
      password: newPassword,
      passwordConfirm: reNewPassword,
    };

    setIsLoading(true);
    const response = await Patch(url, params, apiHeader(accessToken));
    setIsLoading(false);

    if (response !== undefined) {
      toast.success("Password changed successfully.");
      dispatch(saveLoginUserData(response?.data));
      setShow(false);
    }
  };

  return (
    <ModalSkeleton
      modalWidth={"38%"}
      modalPadding={"60px"}
      show={show}
      setShow={setShow}
      className={classes.modalMain}
    >
      <Container>
        <Row className={classes.input_mar}>
          <div className={"text-center"}>
            <h3>Change Password</h3>
          </div>
          <Col md={12}>
            <label>Current Password</label>
            <Input
              className={classes.cus_input}
              leftIcon={<LockIcon />}
              placeholder={"********"}
              type="password"
              value={oldPassword}
              setter={setOldPassword}
            />
          </Col>
          <Col md={12}>
            <label>New Password</label>
            <Input
              className={classes.cus_input}
              leftIcon={<LockIcon />}
              placeholder={"********"}
              type="password"
              value={newPassword}
              setter={setNewPassword}
            />
          </Col>
          <Col md={12}>
            <label>Re Enter New Password</label>
            <Input
              className={classes.cus_input}
              leftIcon={<LockIcon />}
              placeholder={"********"}
              type="password"
              value={reNewPassword}
              setter={setReNewPassword}
            />
          </Col>

          <div className={classes.lgn_btn_div}>
            <Button primary onClick={handlePasswordChange} disabled={isLoading}>
              {isLoading ? "Updating..." : "Update"}
            </Button>
          </div>
        </Row>
      </Container>
    </ModalSkeleton>
  );
};

export default ChangePasswordModal;
